// A régua do movimento do explorador.
//
// Mora num módulo próprio porque tem DOIS leitores, e o segundo é o que obriga:
// quem anda (`AvatarCaminhante`) e quem enquadra (`Tabuleiro`). A câmera espera a
// caminhada terminar antes de reenquadrar, e para esperar precisa saber quanto ela
// dura. Escrever o número nos dois lugares é o defeito que a cortina de neblina já
// teve (ver PassagemLeva): eles empatavam por coincidência, e quem mexesse num
// esquecia o outro.

// VELOCIDADE, e não duração por nó — em px por segundo.
//
// Era `DURACAO_POR_NO = 900`, o que dava ao avatar o mesmo tempo para vencer
// qualquer vão. Funcionava enquanto o espaçamento fosse fixo em 184px; deixou de
// funcionar quando os nós passaram a se espalhar pela faixa. Numa trilha de 3
// fases o vão vai a 320px, e cobrir isso em 900ms é 2,4x a velocidade de uma
// trilha longa: foi reportado como "em trilha curta o boneco anda acelerado".
//
// 204 px/s é exatamente a velocidade que os 184px em 900ms davam — o valor
// histórico, agora expresso como o que ele sempre foi de fato.
export const VELOCIDADE = 204;

// Piso: abaixo disto o deslocamento lê como corte, não como caminhada, e os
// saltos (450ms cada) não têm tempo de acontecer nem uma vez.
export const DURACAO_MINIMA = 600;

// Teto. Concluir várias fases entre dois refetches é raro (só acontece com o
// aluno abrindo itens em outra aba), e sem teto uma trilha de 20 itens renderia
// uma caminhada de dezenas de segundos.
export const DURACAO_MAXIMA = 2400;

/**
 * Quanto dura a caminhada, em ms.
 *
 * A distância sai do PERCURSO — quantos nós ele venceu, vezes o vão entre eles —
 * e não da diferença entre as porcentagens: quando a leva nova reparte a faixa,
 * essa diferença chega a ser NEGATIVA (o nó seguinte fica numa porcentagem menor
 * que o anterior, porque o espaçamento apertou), e o avatar "andava para trás" na
 * duração mínima.
 *
 * @param {number} fasesVencidas nós atravessados neste trajeto
 * @param {number} espaco        px entre dois nós
 */
export function duracaoDaCaminhada(fasesVencidas, espaco) {
  const distanciaPx = Math.abs(fasesVencidas) * espaco;
  // Arredondado aqui, e não só no `style` de quem anda: o número virou também um
  // `setTimeout` (a câmera espera a caminhada), e um vão de 184px dá 901,96ms —
  // fração que o relógio de teste trunca para 901 e que não descreve nada.
  return Math.round(
    Math.min(
      DURACAO_MAXIMA,
      Math.max(DURACAO_MINIMA, (distanciaPx / VELOCIDADE) * 1000)
    )
  );
}
